import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')({
  '& .RaLayout-contentWithSidebar': {
    marginTop: '40px',
  },
});
